module.exports = __webpack_public_path__ + "img/bg2.8233c62a.svg";